import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'

import { MerchantHistoriesFetchParamsSchemas } from 'schemas/merchantHistoriesSchemas'
import { MerchantHistoriesFetchParamsTypes } from 'types/merchantHistories'

export const useMemberHistoryFilterForm = ({
  defaultValues,
}: {
  defaultValues: MerchantHistoriesFetchParamsTypes
}) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch,
  } = useForm<MerchantHistoriesFetchParamsTypes>({
    resolver: zodResolver(MerchantHistoriesFetchParamsSchemas),
    defaultValues,
  })

  return {
    handleSubmit,
    control,
    errors,
    setValue,
    watch,
  }
}
